import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEmlakjetComponent } from './simple-icons-emlakjet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEmlakjetComponent ],
    exports:      [ SimpleIconsEmlakjetComponent ],
    bootstrap:    []
})
export class SimpleIconsEmlakjetModule {}
